import { ICustomBinding } from '#/DefaultViewExtensionInterfaces';
import ComponentManager from '@/Management/ComponentManager';
import ColumnLayoutRowT from '@/Controls/ColumnLayoutRow';

export default class ColumnLayoutBinding implements ICustomBinding {

    initBinding() {
        ko.bindingHandlers.columnLayout = {
            init: (node: HTMLElement, valueAccessor: () => any) => {
                let ColumnLayoutRow = ComponentManager.getControl<typeof ColumnLayoutRowT>('ColumnLayoutRow');

                let layout = $(node);
                let options = valueAccessor();
                let rows = options.rows();

                options.parent.elements = [];

                for (let i = 0; i < rows.length; i++) {
                    let columnLayoutRow = new ColumnLayoutRow(rows[i], $('<div>').appendTo(layout));
                    let tuple = columnLayoutRow.getTuple();

                    options.parent.elements.push(columnLayoutRow);
                }
            }
        };
    }
}